// converts US day indeces (Sunday first) to standard day indeces (Monday first)
export const correctDayIndex = (index: number) => {
  if (index === 0) {
    return 6
  }

  return index - 1
}
